<template>
    <div>
		<ListDenda v-if="isListDenda"
		           @createpotomgan="showcreatepotonganx"
		           @detailListPotongan="showlistpotonganx"
		           v-on:backtolistpenggajian="backtopenggajian"
		/>
        <ListPotongan v-if="islistpotongan" v-on:backtolistdenda="showlistdenda"
                      v-on:createpotomgan="showcreatepotonganx" v-on:detailpotonganx="showdetailpotonganx"
                      v-on:bayarpotongan="showbayarpotonganx"  ref="listpotonganx"
                      :idkaryawan="idkaryawan"
        />
        <TambahPotonganx v-if="iscreatepotongan" v-on:backtolistpotonganx="showlistdenda"
                         @detailListPotongan="showlistpotonganx"
        />
        <BayarPotonganx v-if="isbayarpotonganx" v-on:backtolistpotx="showdetailpotongansx"
                        v-on:riwayatpotongan="showriwayatpotongansx" v-bind:dataidpotonganx="dataidpotonganx"
                        :idkaryawan="idkaryawan"
						ref="bayarpotonganref"
        />
        <DetailPotonganx v-if="isdetailpembayaran" v-bind:dataidpotonganx="dataidpotonganx"
                         v-on:backtolistpotx="showdetailpotongansx" v-on:riwayatpotongan="showriwayatpotonganx"/>

        <RiwayatCicilPotongan v-if="isriwayatpotongan" v-bind:dataidpotonganx="dataidpotonganx"
                              v-on:backtodetailcicil="showdetailpotonganfromriwayatx" v-on:backtobayar="showbayarpotonganfromriwayatx"/>
    </div>
</template>

<script>
    import ListPotongan from "./ListPotongan";
    import TambahPotonganx from "./TambahPotonganx";
    import BayarPotonganx from "./BayarPotonganx";
    import DetailPotonganx from "./DetailPotonganx";
    import RiwayatCicilPotongan from "./RiwayatCicilPotongan";
    import ListDenda from "@/components/penggajian/Potongan Gaji/ListDenda";
    export default {
        name: "AddPotongan",
        components:{DetailPotonganx, BayarPotonganx, TambahPotonganx, ListPotongan, RiwayatCicilPotongan, ListDenda},
        data(){
            return{
            	isListDenda:false,
                islistpotongan:false,
                iscreatepotongan:false,
                isbayarpotonganx:false,
                isdetailpembayaran:false,
                isdetailpembayarancicil:false,
                isriwayatpotongan:false,

	            idkaryawan: "",

                dataidpotonganx:{
                    idpotonganx:'',
                    islunas:'',
                }
            }
        },
        mounted() {
            this.showlistdenda()
        },
        methods:{
	        showlistdenda(){
		        this.isListDenda = true
		        this.islistpotongan = false;
		        this.iscreatepotongan = false;
		        this.isbayarpotonganx=false;
		        this.isdetailpembayaran =false;
		        this.isdetailpembayarancicil =false;
		        this.isriwayatpotongan=false
	        },
            showlistpotonganx(idkaryawan){
	        	this.idkaryawan = idkaryawan

            	this.isListDenda = false
                this.islistpotongan = true;
                this.iscreatepotongan = false;
                this.isbayarpotonganx=false;
                this.isdetailpembayaran =false;
                this.isdetailpembayarancicil =false;
                this.isriwayatpotongan=false

	            setTimeout(() => {
		            this.$refs.listpotonganx.listpotongansx(idkaryawan)
	            }, 200)
				window.scrollTo(0,0)
            },

            showcreatepotonganx(){
	            this.isListDenda = false
                this.islistpotongan = false;
                this.iscreatepotongan = true;
                this.isbayarpotonganx=false;
                this.isdetailpembayaran =false;
                this.isdetailpembayarancicil =false;
                this.isriwayatpotongan=false
            },

            showbayarpotonganx(idpotonganx){
	            this.isListDenda = false
                this.islistpotongan = true;
                this.iscreatepotongan = false;
                this.isbayarpotonganx=true;
                this.isdetailpembayaran =false;
                this.isdetailpembayarancicil =false;
                this.isriwayatpotongan=false;
                this.dataidpotonganx.idpotonganx=idpotonganx;
                $('#listpotonganx').hide();
				window.scrollTo(0,0)
            },

            showbayarpotonganfromriwayatx(val){
	            this.isListDenda = false
                this.islistpotongan = true;
                this.iscreatepotongan = false;
                this.isbayarpotonganx=true;
                this.isdetailpembayaran =false;
                this.isdetailpembayarancicil =false;
                this.isriwayatpotongan=false;
                this.dataidpotonganx.idpotonganx=val.id;
                this.dataidpotonganx.islunas=val.islunas;
                $('#listpotonganx').hide();
            },

            showdetailpotonganx(idpotonganx){
	            this.isListDenda = false
                this.islistpotongan = true;
                this.iscreatepotongan = false;
                this.isbayarpotonganx=false;
                this.isdetailpembayaran =true;
                this.isriwayatpotongan=false;
                $('#listpotonganx').hide();
                this.dataidpotonganx.idpotonganx=idpotonganx;
            },

            showdetailpotonganfromriwayatx(val){
	            this.isListDenda = false
                this.islistpotongan = true;
                this.iscreatepotongan = false;
                this.isbayarpotonganx=false;
                this.isdetailpembayaran =true;
                this.isriwayatpotongan=false;
                $('#listpotonganx').hide();
                this.dataidpotonganx.idpotonganx=val.id;
                this.dataidpotonganx.islunas=val.islunas;
            },

            showdetailpotongansx(){
	            this.isListDenda = false
                this.islistpotongan = true;
                this.iscreatepotongan = false;
                this.isbayarpotonganx=false;
                this.isdetailpembayaran =false;
                this.isdetailpembayarancicil =false;
                this.isriwayatpotongan=false;
                $('#listpotonganx').show();
                this.$refs.listpotonganx.listpotongansx(this.idkaryawan);
                this.backButtonPressed(this.$refs.listpotonganx.backtolistpenggajian)
            },

            showriwayatpotonganx(val){
	            this.isListDenda = false
                this.islistpotongan = true;
                this.iscreatepotongan = false;
                this.isbayarpotonganx=false;
                this.isdetailpembayaran =false;
                this.isriwayatpotongan=true;
                $('#listpotonganx').hide();
                $('#backtopembayaran').hide();
                this.dataidpotonganx.idpotonganx=val.id;
                this.dataidpotonganx.islunas=val.islunas
				window.scrollTo(0,0)
            },

            showriwayatpotongansx(val){
	            this.isListDenda = false
                this.islistpotongan = true;
                this.iscreatepotongan = false;
                this.isbayarpotonganx=false;
                this.isdetailpembayaran =false;
                this.isriwayatpotongan=true;
                $('#listpotonganx').hide();
                $('#backtodetail').hide();
                this.dataidpotonganx.idpotonganx=val.id;
                this.dataidpotonganx.islunas=val.islunas;
            },

            backtopenggajian(){
                this.$emit('backtolistpenggajian')
            }
        }

    }
</script>

<style scoped>

</style>